import ObjectMapController from "./object_map_controller"

export default class ExchangeMarketAssetsMapController extends ObjectMapController {
  static values = {
    ...ObjectMapController.values,
    subjectType: "asset",
    parentSubjectType: "market",
  }
}
